var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page --transfer" }, [
    _c("div", { staticClass: "content" }, [
      _c("h1", [
        _vm._v(
          _vm._s(_vm.__("Cloning your website", "bluehost-site-migrator"))
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.__(
              "Please wait for the cloning process to complete, once completed, we ",
              "bluehost-site-migrator"
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.__(
              "will issue you your transfer key.",
              "bluehost-site-migrator"
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal" },
        [
          _c("p", [_vm._v(_vm._s(_vm.message))]),
          _vm._v(" "),
          _c("ProgressBar", {
            attrs: {
              isAnimated: true,
              progressPercentage: _vm.progressPercentage,
            },
          }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "button-secondary",
              attrs: { to: "/compatible", tag: "button" },
            },
            [
              _vm._v(
                _vm._s(_vm.__("Cancel Transfer", "bluehost-site-migrator")) +
                  "\n\t\t\t"
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("img", { attrs: { src: _vm.imageSrc } }),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }